"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToInvoiceAmount = exports.getEntries = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
function getEntries(query) {
    return api_1.default
        .get("/api/report/financial-revenue?".concat(query_string_1.default.stringify(query)))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getEntries = getEntries;
function getToInvoiceAmount() {
    return api_1.default.get("/api/report/financial-revenue/to-invoice").then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getToInvoiceAmount = getToInvoiceAmount;
